module.exports = __webpack_public_path__ + "static/img/bg1.99cf831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg1.png
// module id = /sIz
// module chunks = 0